const translations = {
  ar: {
    title: 'إدارة طلبات السلفة',
    pendingRequests: 'الطلبات المعلقة',
    approved: 'معتمد',
    disbursed: 'مصروف',
    totalAmount: 'المبلغ الإجمالي',
    pending: 'معلق',
    completed: 'مكتمل',
    rejected: 'مرفوض',
    all: 'الكل',
    employeeName: 'اسم الموظف',
    employeeCode: 'كود الموظف',
    amount: 'المبلغ',
    installments: 'الأقساط',
    reason: 'السبب',
    urgency: 'الأولوية',
    date: 'التاريخ',
    remaining: 'المتبقي',
    pleaseWait: 'الرجاء الانتظار أثناء جلب الطلبات',
    noRequests: 'لا توجد طلبات',
    tryAgain: 'حاول مرة أخرى',
    requestDetails: 'تفاصيل الطلب',
    requestedAmount: 'المبلغ المطلوب',
    numberOfInstallments: 'عدد الأقساط',
    installmentAmount: 'قيمة القسط',
    totalRepaid: 'المبلغ المسدد',
    remainingBalance: 'الرصيد المتبقي',
    installmentsPaid: 'الأقساط المسددة',
    status: 'الحالة',
    requestedDate: 'تاريخ الطلب',
    reviewedDate: 'تاريخ المراجعة',
    referenceNumber: 'رقم المرجع',
    repaymentStartDate: 'تاريخ بدء السداد',
    nextPaymentDate: 'تاريخ الدفع القادم',
    repaymentHistory: 'سجل السداد',
    installmentNum: 'القسط رقم',
    paymentDate: 'تاريخ الدفع',
    method: 'الطريقة',
    reference: 'المرجع',
    notes: 'ملاحظات',
    close: 'إغلاق',
    cancel: 'إلغاء',
    approve: 'موافقة',
    reject: 'رفض',
    processSolfa: 'معالجة طلب السلفة',
    disbursementMethodLabel: 'طريقة الصرف',
    referenceNumberRequired: 'رقم المرجع *',
    referenceNumberPlaceholder: 'أدخل رقم المعاملة',
    confirmDisbursement: 'تأكيد الصرف',
    bankTransfer: 'تحويل بنكي',
    cash: 'نقدي',
    check: 'شيك',
    normal: 'عادي',
    high: 'مرتفع',
    urgent: 'عاجل',
    unknownEmployee: 'موظف غير معروف',
    provideRejectionReason: 'يرجى تقديم سبب الرفض',
    provideReferenceNumber: 'يرجى تقديم رقم المرجع',
    requestApprovedSuccess: 'تمت الموافقة على طلب السلفة بنجاح!',
    requestRejected: 'تم رفض طلب السلفة',
    solfaDisbursedSuccess: 'تم صرف السلفة بنجاح!',
    approvalFailed: 'فشل الموافقة',
    rejectionFailed: 'فشل الرفض',
    disbursementFailed: 'فشل الصرف',
    refresh: 'تحديث',
    loading: 'جاري التحميل...',
    noRequestsFound: 'لا توجد طلبات',
    viewDetails: 'عرض التفاصيل',
    processRequest: 'معالجة الطلب',
    disburse: 'صرف',
    disburseSolfa: 'صرف السلفة',
    employee: 'الموظف',
    reviewedBy: 'تمت المراجعة بواسطة',
    approvalNotes: 'ملاحظات الموافقة',
    rejectionReason: 'سبب الرفض',
    disbursedDate: 'تاريخ الصرف',
    disbursementMethod: 'طريقة الصرف',
    approvalNotesOptional: 'ملاحظات الموافقة (اختياري)',
    approvalNotesPlaceholder: 'أضف أي ملاحظات حول هذه الموافقة...',
    rejectionReasonIfRejecting: 'سبب الرفض (في حالة الرفض)',
    rejectionReasonPlaceholder: 'اشرح سبب رفض هذا الطلب...',
    currencySuffix: 'ج.م',
    currencyPrefix: '',
  },
  en: {
    title: 'Solfa Requests Management',
    pendingRequests: 'Pending Requests',
    pending: 'Pending',
    loading: 'Loading...',
    pleaseWait: 'Please wait while requests are fetched',
    noRequests: 'No requests',
    noRequestsFound: 'No requests found',
    tryAgain: 'Try again',
    requestDetails: 'Request Details',
    requestedAmount: 'Requested Amount',
    numberOfInstallments: 'Number of Installments',
    installmentAmount: 'Installment Amount',
    totalRepaid: 'Total Repaid',
    remainingBalance: 'Remaining Balance',
    installmentsPaid: 'Installments Paid',
    status: 'Status',
    requestedDate: 'Requested Date',
    reviewedDate: 'Reviewed Date',
    referenceNumber: 'Reference Number',
    repaymentStartDate: 'Repayment Start Date',
    viewDetails: 'View Details',
    processRequest: 'Process Request',
    disburse: 'Disburse',
    disburseSolfa: 'Disburse Solfa',
    approvalNotesOptional: 'Approval Notes (optional)',
    approved: 'Approved',
    disbursed: 'Disbursed',
    totalAmount: 'Total Amount',
    completed: 'Completed',
    rejected: 'Rejected',
    all: 'All',
    cancel: 'Cancel',
    close: 'Close',
    approve: 'Approve',
    reject: 'Reject',
    employeeName: 'Employee Name',
    employeeCode: 'Employee Code',
    amount: 'Amount',
    installments: 'Installments',
    reason: 'Reason',
    urgency: 'Urgency',
    date: 'Date',
    remaining: 'Remaining',
    employee: 'Employee',
    reviewedBy: 'Reviewed By',
    approvalNotes: 'Approval Notes',
    rejectionReason: 'Rejection Reason',
    disbursedDate: 'Disbursed Date',
    disbursementMethod: 'Disbursement Method',
    referenceNumber: 'Reference Number',
    repaymentStartDate: 'Repayment Start Date',
    nextPaymentDate: 'Next Payment Date',
    repaymentHistory: 'Repayment History',
    installmentNum: 'Installment #',
    paymentDate: 'Payment Date',
    method: 'Method',
    reference: 'Reference',
    notes: 'Notes',
    disbursementMethodLabel: 'Disbursement Method',
    referenceNumberRequired: 'Reference Number *',
    referenceNumberPlaceholder: 'Enter transaction reference',
    confirmDisbursement: 'Confirm Disbursement',
    bankTransfer: 'Bank Transfer',
    cash: 'Cash',
    check: 'Check',
    normal: 'Normal',
    high: 'High',
    urgent: 'Urgent',
    unknownEmployee: 'Unknown Employee',
    provideRejectionReason: 'Please provide a rejection reason',
    provideReferenceNumber: 'Please provide a reference number',
    requestApprovedSuccess: 'Solfa request approved successfully!',
    requestRejected: 'Solfa request rejected',
    solfaDisbursedSuccess: 'Solfa disbursed successfully!',
    approvalFailed: 'Approval failed',
    rejectionFailed: 'Rejection failed',
    disbursementFailed: 'Disbursement failed',
    refresh: 'Refresh',
    processSolfa: 'Process Solfa Request',
    currencySuffix: '',
    currencyPrefix: 'EGP ',
  },
};

export default translations;